export const extractGreetingFromTime = (messages: any, hour: any, name: string = '', title: string = '', firstName: string) => {
    var today = new Date()
    var curHr = hour || today.getHours()

    const nameParts = { 
        title,
        name,
        firstName
    }

    if (curHr < 12) {
        return messages.greetings.morning(nameParts)
    } else if (curHr < 18) {
        return messages.greetings.afternoon(nameParts)
    } else {
        return messages.greetings.evening(nameParts)
    }
}

export const snakeToCamel = (str: string) =>
    str.toLowerCase().replace(/([-_][a-z])/g, (group) =>
        group
            .toUpperCase()
            .replace('-', '')
            .replace('_', '')
    )

export const camelToBendyBus = (str: string) => {
    return str
        .replace(/[\w]([A-Z])/g, (m) => {
            return m[0] + '-' + m[1]
        })
        .toLowerCase()
}
